import * as consts from '../data/base/consts'

/**
 * 一些公共的方法
 */
import { DOM } from './dom'
import { PRELOADER } from './preloader'

var UTILS = {
    // 获取时间格式
    getTimeStrByInt(num) {
        return num < 10 ? ('0' + num) : num;
    },
	// 获取时间格式：反转
	getTimeNumByString(string) {
	    return string.charAt(0) == '0' ? parseInt(string.charAt(1)) : parseInt(string);
	},
	// 获取年月日的中文表达:::算法优化
	getChineseWordByNumber(type, number) {
	    var resultStr = '';
	    var tempArr = (number.toString()).split('');
	    var time = parseInt(number);
	    if (type == 'year') {
	        for (var i = 0; i < tempArr.length; i++) {
	            resultStr += consts.CONST_YEAR_WORD[tempArr[i]];
	        }
	    } else if (type == 'month') {
	        resultStr += (consts.CONST_MONTH_WORD[time - 1] + '月');
	    } else if (type == 'day') {
	        resultStr += consts.CONST_DAY_WORD[time - 1];
	    }
	    // console.log("getChineseWordByNumber", type, time, resultStr)
	    return resultStr;
	},
	// 获取年月日的数字表达:::算法优化
	getNumberByChineseWord(type, word) {
		var resultNumber = 0;
		switch(type) {
			case 'year':
				var yearArr = word.split(''), yearNArr = [];
				yearArr.forEach(yearT=>{
					var y = consts.CONST_YEAR_WORD.indexOf(yearT);
					yearNArr.push(y);
				});
				resultNumber = parseInt(yearNArr.join(''));
				break;
			case 'month':
				word = word.replace('月', '');
				resultNumber = consts.CONST_MONTH_WORD.indexOf(word)+1;
				break;
			case 'day':
				resultNumber = consts.CONST_DAY_WORD.indexOf(word)+1;
				break;
			default:
				break;
		}
		console.log('getNumberByChineseWord', type, word, resultNumber)
		return resultNumber;
	},
	// 根据月和日获取星座
	getConstellationByMD(month, day) {
		var monthIndex = month-1,
			startD = consts.CONST_CONSTELLATION_START_DAY[monthIndex],
			endD = consts.CONST_CONSTELLATION_END_DAY[monthIndex],
			textArr = consts.CONST_CONSTELLATION_TEXT;
		var resultData = day <= endD ? textArr[monthIndex] : textArr[monthIndex+1];
			resultData = month >= 12 && day >= startD? textArr[0] : resultData; 
		return resultData;
	},
    // 根据数组获取 yy-mm-dd hh:mm:ss 格式的时间
    getYmdHmsTimeStrByArr(arr) {
        var timeStr = '';
        for(var i = 0; i < arr.length; i++){
            timeStr += this.getTimeStrByInt(arr[i]);
            if(i < 2){
                timeStr += '-';
            }else if (i == 2){
                timeStr += ' ';
            }else if (i == 3 || i == 4){
                timeStr += ':';
            }
        }
        return timeStr;
    },
	/**
	 * 获取名称的第一个文字(忽略emoji表情)
	 * @param {Object} string
	 */
	getFirstLetter(string) {
		if(!string) { return '' };
		var regRule = /[\u{1F601}-\u{1F64F}\u{2702}-\u{27B0}\u{1F680}-\u{1F6C0}\u{1F170}-\u{1F251}\u{1F600}-\u{1F636}\u{1F681}-\u{1F6C5}\u{1F30D}-\u{1F567}]/gu;
		if(string.match(regRule)) {
			string = string.replace(regRule, '');
		}
		return string.charAt(0);
	},
	/**
	 * 获取随机数
	 * @param {Object} max
	 */
	getRandomInt(max) {
	  return Math.floor(Math.random() * Math.floor(max));
	},
	/**
	 * 通过时间戳获取时间信息
	 * @param {Object} time
	 */
	getBirthdayInfoByTimeStamp(time) {
		var date = new Date(time*1000),
			year = date.getFullYear(), month = date.getMonth(), day = date.getDate(), hour = date.getHours(), minute = UTILS.getTimeStrByInt(date.getMinutes()),
			constellation = UTILS.getConstellationByMD(month+1, day);
		var dateStr = year+'年'+(month+1)+'月'+day+'日 '+hour+':'+minute;
		return {
			date: dateStr,
			constellation: constellation
		};
	},
	// 在对象数组里取包含特定id的object的index
    getIdIndexInObjectArray(objectArr, id) {
        for(var object of objectArr){
            var index = objectArr.indexOf(object);
            if(object.id == id){
                return index;
            }
        }
        return -1;
    },
	// 获取分享配置的标题参数5组
	// 2023年我的卯力值是xx，击败了XX%的网友，速来看看你的前兔如何。
	// 2023年玉兔过接寅虎，看你前兔如何！我是XXX有前兔，XXX有前兔，XXX有前兔，XXX有前兔。
	// 2023年兔然转运，我的卯力值是XXX，XXX有前途，XXX有前途，XXX有前途。看你前兔如何？
	// 2023年我的卯力值是XX！我是XXX有前兔！看你前兔如何？
	// 2023年你是兔然发财还是压力兔然？我是XXX兔然，XXX兔然，XXX兔然，XXX兔然。
	// 2023年你的卯力值已准备好，速来看。我是XXXX卯力强，XXX强，XXX旺，XXX 旺，你来测测看。	
	getShareArrByData(data) {
		// console.error('data------', data.des, data.score, data.cowName)
		var randIndex = UTILS.getRandomInt(6),
			textArr = [];
		textArr.push('2023年我的卯力值是'+parseInt(data.score)+'，击败了'+Math.round(data.score)+'%的网友，速来看看你的前兔如何。');
		textArr.push('2023年玉兔过接寅虎，看你前兔如何！我是'+data.title+'！'+data.cowName.join('，')+'。');
		textArr.push('2023年兔然转运，我的卯力值是'+parseInt(data.score)+'！'+data.cowName.join('，')+'。看你前兔如何？');
		textArr.push('2023年我的卯力值是'+parseInt(data.score)+'！我是'+data.title+'！看你前兔如何？');
		textArr.push('2023年你是兔然发财还是压力兔然？我是'+data.title+'！'+data.cowName.join('，')+'。');
		textArr.push('2023年你的卯力值已准备好，速来看。我是'+data.title+'，'+data.cowName.join('，')+'，你来测测看。');
		// console.log('getShareArrByData------', textArr[randIndex]);
		return textArr[randIndex];
	},
	getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        };
        return null;
    },
    isPoneAvailable(number) {
        var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(number)) {
            return false;
        } else {
            return true;
        }
    },
}

export {
    UTILS, DOM, PRELOADER
}